'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CodeEditor = require('../CodeEditor');

var _CodeEditor2 = _interopRequireDefault(_CodeEditor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CodeExampleTitanium = function CodeExampleTitanium(_ref) {
	var code = _ref.code;

	return _react2.default.createElement(_CodeEditor2.default, {
		code: code,
		mode: 'javascript',
		readOnly: true
	});
};

CodeExampleTitanium.propTypes = {
	/**
  * The code example.
  */
	code: _propTypes2.default.string.isRequired
};

var _default = CodeExampleTitanium;
exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(CodeExampleTitanium, 'CodeExampleTitanium', 'src/components/OpenAPI/CodeExampleTitanium.jsx');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/OpenAPI/CodeExampleTitanium.jsx');
}();

;